const connectedDialogRoomIds = new Set();

function getDefaultApp() {
  return typeof window !== "undefined" ? window.APP : undefined;
}

export function getCurrentDialogRoomId(app = getDefaultApp()) {
  return app?.hub?.hub_id || app?.dialog?._roomId || null;
}

export function markDialogConnectedForCurrentRoom(app = getDefaultApp()) {
  const roomId = getCurrentDialogRoomId(app);

  if (roomId) {
    connectedDialogRoomIds.add(roomId);
  }
}

export function hasDialogConnectedForCurrentRoom(app = getDefaultApp()) {
  const roomId = getCurrentDialogRoomId(app);

  return Boolean(roomId && connectedDialogRoomIds.has(roomId));
}

export function clearDialogConnectionTracking() {
  connectedDialogRoomIds.clear();
}

export function isHubsVideoStreamSrc(src) {
  return typeof src === "string" && /^hubs:\/\/clients\/[^/]+\/video(?:\?|$)/.test(src);
}

export function shouldDeferHubsVideoStreamLoad({ src, scene, app = getDefaultApp() } = {}) {
  if (!isHubsVideoStreamSrc(src)) {
    return false;
  }

  if (scene?.is?.("entered")) {
    return false;
  }

  return !hasDialogConnectedForCurrentRoom(app);
}

export function shouldShowDialogConnectErrorScreen({ scene, state } = {}) {
  if (state === "failed") {
    return true;
  }

  return !scene?.is?.("entered");
}
